import { computed } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

export const CONV_LIST_FONT_SIZES = ['sm', 'md', 'lg'];
// Compact is the product default — prior hardcoded name size (14.5px) felt too large on PWA.
export const CONV_LIST_FONT_SIZE_DEFAULT = 'sm';

// Tailwind class maps per size token.
// 'md' matches the previous hardcoded ConversationCard.vue sizes.
export const CONV_LIST_FONT_CLASSES = {
  sm: {
    name: 'text-[13px]',
    preview: 'text-[12px]',
    timestamp: 'text-[11px]',
  },
  md: {
    name: 'text-[14.5px]',
    preview: 'text-[13.5px]',
    timestamp: 'text-[12.5px]',
  },
  lg: {
    name: 'text-[16.5px]',
    preview: 'text-[15px]',
    timestamp: 'text-[13.5px]',
  },
};

export const useConversationListFontSize = () => {
  const { uiSettings, updateUISettings } = useUISettings();

  const currentSize = computed(() => {
    const raw = uiSettings.value?.conversation_list_font_size;
    return CONV_LIST_FONT_SIZES.includes(raw)
      ? raw
      : CONV_LIST_FONT_SIZE_DEFAULT;
  });

  const fontClasses = computed(() => CONV_LIST_FONT_CLASSES[currentSize.value]);

  const setFontSize = size => {
    if (!CONV_LIST_FONT_SIZES.includes(size)) return;
    updateUISettings({ conversation_list_font_size: size });
  };

  return { currentSize, fontClasses, setFontSize };
};
